export default function isSafari() {
  return /safari/i.test(navigator.userAgent);
}
